(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    

// /* Slick Slider initialization */
// document.addEventListener('DOMContentLoaded', function() {
//   if (window.innerWidth <= 768 && typeof jQuery !== 'undefined' && jQuery.fn.slick) {
//     jQuery('.mobile-slider').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       infinite: true,
//       arrows: false,
//       dots: true,
//       autoplay: true,
//       autoplaySpeed: 3000,
//       centerMode: false,
//       mobileFirst: true,
//       responsive: [
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1
//           }
//         }
//       ]
//     });
//   }
// });


/* Slick Slider initialization */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768 && typeof jQuery !== 'undefined' && jQuery.fn.slick) {
    jQuery('.mobile-slider').slick({
      slidesToShow: 2, // 1 se badal kar 2 kar diya
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-collections-slider"] && !Shopify.designMode) return;
  try {
    
/* JavaScript disabled to prevent 1-by-1 slider logic */

  } catch(e) { console.error(e); }
})();
})();
